import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../../context/GlobalContext';

import { applyPromotion, overrideSCInstallment, instalmentPatch, subsidyPatch, updateAndValidateSC, captureData } from '../../../api/api';
import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';

import { handleApiError } from '../../../functions/handleApiError';
import captureStructure from '../../../captureStructure.json';

import './DeviceTerms.scss';
import { PROD } from '../../../Constants/index';
interface Props {
    handleHeaderCancel: () => void;
}

const win: any = window;
const serverURL = win['base_portal_url'];
const env = win["env_variable"];

function DeviceTerms({ handleHeaderCancel }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, scData, cartId, lang, promotionType, productId, promotionApplied, deviceFlow, appliedInstallment, subPageToDisplay: stepName, msisdn, otpValue, customerAccount, promoTypeCode, promoTypeValue } = state;
    const newStackValue = customerAccount?.NewStack ? customerAccount?.NewStack : "N";

    const { t } = useTranslation();

    const [checked, setChecked] = useState(false);
    const [htmlData, setHTMLData] = useState<any>(null);

    const wajidName = promotionApplied?.name ? promotionApplied?.name.replaceAll(' ', '+') : '';
    const promotionName = promotionType === 'Raqi' ? promotionApplied?.name : wajidName;
    const cartItemId = scData?.offerContainer[0]?.cartItem[0]?.id ? scData?.offerContainer[0]?.cartItem[0]?.id : "";
    const itemPriceId = scData?.offerContainer[0]?.cartItem[0]?.itemPrice[0]?.priceId;
    const ocId = scData?.offerContainer[0]?.id

    //"Device_Subsidy_3600" ---> Raqi
    //Wajid Extra Subsidy // Wajid+Extra+Subsidy

    useEffect(() => {
        if (deviceFlow === 'subsidy') {
            const url = `${serverURL}/web/${lang}/devices/terms-and-conditions/subsidy/${promotionName}`;
            dispatch({ type: "LOADER", payload: { loading: true } });

            fetch(url)
                .then((res) => {
                    return res.text()
                }).then(data => {
                    setHTMLData(data)
                    dispatch({ type: "LOADER", payload: { loading: false } });
                })
        } else {
            const url = win["env_variable"]?.toUpperCase() === PROD
                ? `${serverURL}/web/${lang}/devices/terms-and-conditions/installment`
                : `${serverURL}/wps/wcm/connect/${lang}/devices/terms-and-conditions/installment?projectid=6baebf6d-faba-48a8-ae40-0d2066613800`;

            fetch(url)
                .then((res) => {
                    return res.text()
                }).then(data => {
                    setHTMLData(data)
                    console.log("setHTMLData", data)
                    setTimeout(() => {
                        const monthlyInstalment: any = document.getElementById('monthly_installment');
                        const upfrontPayment: any = document.getElementById('upfront_payment');
                        const total_payment: any = document.getElementById('total_payment');


                        monthlyInstalment.innerHTML = appliedInstallment?.MonthlyCommitmentAmt;
                        upfrontPayment.innerHTML = appliedInstallment?.PromotionCommitmentPeriod;
                        total_payment.innerHTML = `${t("SAR")} ${appliedInstallment?.TotalDeviceInstallmentAmount}`;
                    }, 0)
                })
        }
    }, [])

    const handleCheckbox = () => {
        setChecked(prevState => !prevState)
    }

    const handleBackArrow = () => {
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceClaimPlan' } })
    }

    const updateAndValidateSCAPI = () => {
        updateAndValidateSC(cartId)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    captureDataApi(res?.data?.shoppingCart)
                } else {
                    const config = Object.assign(res?.config, { serviceName: 'update-and-validate' });
                    const response = { ...res, config }
                    handleApiError(response, stepName);
                }
            }).catch(err => {
                const config = Object.assign(err?.config, { serviceName: 'update-and-validate' });
                const error = { ...err, config }
                handleApiError(error, stepName);
            })
    }

    const captureDataApi = (scData: any) => {
        const sections: any = ({
            ...captureStructure,
            steps: captureStructure?.steps.map((step: any) => ({
                ...step,
                offerContainerId: scData.offerContainer[0].id,
                options: [
                    {
                        name: 'Login',
                        value: 'Mobily number',
                        fields: [
                            {
                                name: 'Mobily number',
                                value: msisdn
                            }
                        ]
                    }
                ],
                fields: step.fields.map((field: any) => {
                    let fieldValues = field;

                    if (field.name === 'Continue As Guest') {
                        fieldValues = ({
                            ...field,
                            value: 'No'
                        })
                    } else if (field.name === 'OTP') {
                        fieldValues = ({
                            ...field,
                            value: otpValue
                        })
                    } else if (field.name === 'CustomerRelatedAcccountInquiryResponse') {
                        fieldValues = ({
                            ...field,
                            value: JSON.stringify(customerAccount)
                        })
                    } else if (field.name === 'MobilyMSISDN') {
                        fieldValues = ({
                            ...field,
                            value: '' //pass encrpty BMNumber value when using ID Number in Login
                        })
                    } else if (field.name === 'promoTypeCode') {
                        fieldValues = ({
                            ...field,
                            value: promoTypeCode
                        })
                    } else if (field.name === 'promoTypeValue') {
                        fieldValues = ({
                            ...field,
                            value: promoTypeValue
                        })
                    } else if (field.name === 'promotionTermAndCondition') {
                        fieldValues = ({
                            ...field,
                            value: 'true'
                        })
                    } else if (field.name === 'deviceInstallment') {
                        fieldValues = ({
                            ...field,
                            value: deviceFlow === 'subsidy' ? 'false' : 'true'
                        })
                    } else if (field.name === 'NewStack') {
                        fieldValues = ({
                            ...field,
                            value: newStackValue
                        })
                    }

                    return fieldValues
                })
            }))

        });

        captureData(scData, [sections])
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceSubsidySuccess" } });
                    dispatch({ type: "LOADER", payload: { loading: false } });
                } else {
                    handleApiError(res, stepName);
                }
            }).catch(err => {
                handleApiError(err, stepName);
            })
    }

    const handleApplySubsidy = () => {

        dispatch({ type: "LOADER", payload: { loading: true } });

        if (deviceFlow === 'subsidy') {
            subsidyPatchAPI()
        } else {
            instalmentPatchAPI()
        }
    }

    const instalmentPatchAPI = () => {
        instalmentPatch(scData?.id, ocId, appliedInstallment?.MonthlyCommitmentAmt, appliedInstallment?.PromotionCommitmentPeriod, appliedInstallment?.PromotionTechnicalName, appliedInstallment?.TotalDeviceInstallmentAmount)
            .then((res: any) => {
                if (res?.status === 201 && res?.data) {
                    instalmentPromotionApplyAPI()
                } else {
                    const config = Object.assign(res?.config, { serviceName: 'instalmentPatch' });
                    const response = { ...res, config }
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    handleApiError(response, stepName);
                }
            }).catch(err => {
                const config = Object.assign(err?.config, { serviceName: 'instalmentPatch' });
                const error = { ...err, config }
                handleApiError(error, stepName);
            })
    }

    const subsidyPatchAPI = () => {
        const req = {
            shoppingCartData: {
                ocId: scData.offerContainer[0]?.id,
                scId: cartId
            },
            promotionData: {
                packageId: productId,
                promotionId: promotionApplied?.id,
                signature: promotionApplied?.signature
            }
        }
        subsidyPatch(scData?.id, ocId, cartItemId)
            .then((res: any) => {
                if (res?.status === 201 && res?.data) {
                    const dutyFreeAmount = res.data.offerContainer?.[0]?.offerContainerTotalPrice?.[0]?.price?.dutyFreeAlteredAmount?.value

                    dispatch({ type: 'SET_UPDATED_PRODUCT_PRICE', payload: { updatedProductPrice: dutyFreeAmount } });
                    applyPromotion(req.shoppingCartData, req.promotionData)
                        .then((res: any) => {
                            if (res.status === 200 && res.data) {
                                updateAndValidateSCAPI();
                            } else {
                                const config = Object.assign(res?.config, { serviceName: 'applyPromotion' });
                                const response = { ...res, config }
                                dispatch({ type: "LOADER", payload: { loading: false } });
                                handleApiError(response, stepName);
                            }
                        }).catch(err => {
                            const config = Object.assign(err?.config, { serviceName: 'applyPromotion' });
                            const error = { ...err, config }
                            handleApiError(error, stepName);
                        })
                } else {
                    const config = Object.assign(res?.config, { serviceName: 'subsidyPatch' });
                    const response = { ...res, config }
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    handleApiError(response, stepName);
                }
            }).catch(err => {
                const config = Object.assign(err?.config, { serviceName: 'subsidyPatch' });
                const error = { ...err, config }
                handleApiError(error, stepName);
            })
    }

    const instalmentPromotionApplyAPI = () => {
        overrideSCInstallment(scData?.id, cartItemId, itemPriceId, ocId)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    updateAndValidateSCAPI();
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    handleApiError(res, stepName);
                }
            }).catch(err => {
                handleApiError(err, stepName);
            })
    }

    return (
        <div className='DeviceTermsNCondition__Container'>
            <HeaderNavigation
                rtl={rtl}
                percent={100}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />

            <div className='DeviceTnC__Content' dangerouslySetInnerHTML={{ __html: htmlData ? htmlData : '' }}></div>

            {/* sticky terms n condition */}
            <div className='DTNC__StickyBox'>
                <div className='STB__Container'>
                    <div className='STB__TnC'>
                        <input aria-label='checkbox' type='checkbox' onChange={handleCheckbox} className='STB__Checkbox' />
                        <Typography rtl={rtl} id="lineType-heading" className='STB__Text'>{deviceFlow === 'subsidy' ? t('Accept_TermsNcondition') : t('installments_terms_conditions')}</Typography>
                    </div>
                    <Button
                        rtl={rtl}
                        className={`STB__ApplyBtn ApplyBtn_${deviceFlow === 'subsidy' ? 'sub' : 'inst'}`}
                        variant={!checked ? 'disabled' : 'default'}
                        onClick={handleApplySubsidy}
                    >
                        {deviceFlow === 'subsidy' ? t('Apply_Subsidy') : t('apply_installments')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default DeviceTerms